import { useMemo } from 'react';

import { DEFAULT_SCREEN_OPTIONS, type ScreenOptionsMap } from '../../../../constants';
import { useRouteTitles } from '../../../messages';

// ─────────────────────────────────────────────────────────────────────────────

export const useHomeTabStackOptions = () => {
  const titles = useRouteTitles();

  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: DEFAULT_SCREEN_OPTIONS,

      // ─── Individual Tabs ─────────────────────────────────────────────────

      Home: { title: titles.homeTitle },
    } satisfies ScreenOptionsMap;
  }, [titles]);
};
